import React, { useState, useEffect } from "react";
import 'react-quill/dist/quill.snow.css';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from "@mui/material";
import ReactQuill from "react-quill";
import { useAddNewsletterMutation, useUpdateNewsletterMutation } from "../api/newsletterApi";
import { Newsletter } from "../types/newsletter";

interface AddEditNewsletterDialogProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  newsletterToEdit?: Newsletter | null;
}

const AddEditNewsletterDialog: React.FC<AddEditNewsletterDialogProps> = ({
  open,
  setOpen,
  newsletterToEdit,
}) => {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [addNewsletter, { isLoading: isAdding }] = useAddNewsletterMutation();
  const [updateNewsletter, { isLoading: isUpdating }] = useUpdateNewsletterMutation();

  const isLoading = isAdding || isUpdating;

  useEffect(() => {
    if (newsletterToEdit) {
      setTitle(newsletterToEdit.subject);
      setContent(newsletterToEdit.content);
    } else {
      setTitle("");
      setContent("");
    }
  }, [newsletterToEdit, open]);

  const handleSubmit = async () => {
    if (!title || !content) return;

    try {
      if (newsletterToEdit?.id) {
        await updateNewsletter({
          id: newsletterToEdit.id,
          body: { subject: title, content }
        }).unwrap();
      } else {
        await addNewsletter({ body: { subject: title, content } }).unwrap();
      }
      setOpen(false);
      setTitle("");
      setContent("");
    } catch (err: any) {
      console.error("Newsletter operation failed", err);
      setErrorMessage(err?.data?.message || err?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{newsletterToEdit ? 'Edit Newsletter' : 'Add Newsletter'}</DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            margin="normal"
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Box mt={2}>
            <ReactQuill value={content} onChange={setContent} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!title || !content || isLoading}
          >
            {isLoading
              ? newsletterToEdit
                ? "Updating..."
                : "Sending..."
              : newsletterToEdit
              ? "Update"
              : "Send"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Dialog */}
      <Dialog open={!!errorMessage} onClose={() => setErrorMessage(null)}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography color="error">{errorMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorMessage(null)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddEditNewsletterDialog;
function Logger() {
  throw new Error("Function not implemented.");
}

